/**
 * Restores the scroll position to the provided HTML element
 * after the supplied function has finished executing
 */
export default async function restoreScrollToElementAfterAction(action, htmlElement) {
  if (htmlElement) {
    const oldTop = htmlElement.getBoundingClientRect().top;

    await action();

    if (htmlElement) {
      const newTop = htmlElement.getBoundingClientRect().top;
      window.scrollBy({
        top: newTop - oldTop,
        left: 0,
        behavior: 'auto',
      });
    }
  } else {
    await action();
  }
}
